export enum EURL {
	LIST_HELPDESK_TICKETS = '/dashboard/listHelpdeskTickets/userProfile-previousTickets-listHelpdeskTickets',
	CALL_USER = '/dashboard/callUser/userProfile-previousTickets-callUser',
	CREATE_HELPDESK_TICKET = '/dashboard/createHelpdeskTicket/userProfile-previousTickets-createHelpdeskTicket',
	GET_ACTIVE_COUPON = '/dashboard/getActiveCouponForUser/userProfile-coupons-getActiveCouponForUser',
	GET_REFERRALS_SUMMARY = '/dashboard/getReferralsSummary/userProfile-referrals-getReferralsSummary',
	GET_CAMPAIGNS = '/dashboard/getCampaigns/userProfile-previousTickets-callUser',
	DOWNLOAD_USER_PAYOUT_DETAILS = '/dashboard/downloadUserPayoutDetails/userProfile-basicDetails-downloadUserPayoutDetails',
	VIEW_PAYOUT_RECORDS = '/dashboard/viewPayoutRecords/userProfile-kycDetails-viewPayoutRecords',
	VIEW_DOB = '/dashboard/viewDOB/userProfile-basicDetails-viewDOB',
	VIEW_PHONE = '/dashboard/viewPhone/userProfile-basicDetails-viewPhone',
	VIEW_EMAIL = '/dashboard/viewEmail/userProfile-basicDetails-viewEmail',
	VIEW_ALTERNATE_PHONE = '/dashboard/getAlternatePhoneNumber/userProfile-basicDetails-viewPhone',
	CANCEL_SUBSCRIPTION = '/dashboard/cancelSubscription/userProfile-basicDetails-cancelSubscription'
}
